<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="12" xl="12">
                <transition name="slide">
                    <b-card>
                        <div slot="header">
                            <div class="card-header-actions">
                            <b-link class="card-header-action btn-setting" to="create" :append="true">
                                <i class="icon-plus"></i>
                            </b-link>
                            </div>
                        </div>
                        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
                            <template slot="name" slot-scope="data">
                            <strong>{{data.item.name}}</strong>
                            </template>
                        </b-table>
                    </b-card>
                </transition>
            </b-col>
        </b-row>

        <ReLogin v-model="showLogin" @success="successLogin" />
    </div>
</template>

<script>

import ReLogin from '../users/ReLogin'
export default {
    name: "Projects",
    components: {
        ReLogin,
    },
    props: {
        caption: {
        type: String,
        default: 'Projects'
        },
        hover: {
        type: Boolean,
        default: true
        },
        striped: {
        type: Boolean,
        default: true
        },
        bordered: {
        type: Boolean,
        default: false
        },
        small: {
        type: Boolean,
        default: false
        },
        fixed: {
        type: Boolean,
        default: false
        }
    },
    data: function() {
        return {
            fields: ["name"],
            currentPage: 1,
            perPage: 20,
            totalRows: 0,
            showLogin: false,
            changeProjectTo: null
        }
    },
    methods: {
        rowClicked(item) {
            this.changeProject(item.uuid)
        },

        changeProject(uuid) {
            if (this.$store.getters.getCurrentProject.uuid == uuid) {
                return false
            }

            this.changeProjectTo = uuid
            this.showLogin = true
        },

         successLogin() {
            const uuid = this.changeProjectTo

            let project = this.$store.getters.project(uuid)
            if (project.suspension_level > 0) {
                this.$mainDialog.msgBoxOk(this.$t('projectSuspended'));
                return
            }

            this.$store.commit("SET_CURRENT_PROJECT", project)

            localStorage.setItem('current_workspace_uuid', project.workspaces[0].uuid)

            this.$store.dispatch('refreshState')
         }
    },
    computed: {
        items() {
            return this.$store.getters.projects
        }
    }
}
</script>
